const popup = document.querySelector(".product-gallery-popup");
const popupBody = popup.querySelector(".product-gallery-popup__body");

let lastFocusedElement = null;

/* ==========================
   Popup
========================== */

document.addEventListener("click", function (e) {

    const item = e.target.closest(".js-open-gallery");

    if (!item || !popup || !popupBody) return;

    // Popup ni andar click thay to popup fari open na thay
    if (item.closest(".product-gallery-popup")) return;

    const currentId = String(item.dataset.mediaId || "");

    lastFocusedElement = item;

    const medias = [
        ...popupBody.querySelectorAll(".product-gallery__media")
    ];

    const targetMedia = medias.find(media =>
        String(media.dataset.mediaId || "") === currentId
    );

    if (!targetMedia) {
        console.warn("Popup media not found:", currentId);
        return;
    }

    popup.classList.add("active");
    popup.setAttribute("aria-hidden", "false");

    document.body.classList.add(
        "product-model-overflow-hidden"
    );

    requestAnimationFrame(() => {

        targetMedia.scrollIntoView({
           behavior: "smooth",
            block: "start"
        });

        const model = targetMedia.querySelector("model-viewer");

        if (model) {
            model.dismissPoster?.();

            requestAnimationFrame(() => {
                model.dismissPoster?.();
            });
        }

        popup.querySelector(
            ".product-gallery-popup__close"
        )?.focus();

    });

});

popup.querySelector(".product-gallery-popup__overlay")
    .addEventListener("click", closeGallery);

popup.querySelector(".product-gallery-popup__close")
    .addEventListener("click", closeGallery);

document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (!popup.classList.contains("active")) return;
    closeGallery();
});

function closeGallery() {

    if (!popup) return;

    popup.classList.remove("active");

    popup.setAttribute("aria-hidden", "true");

    document.body.classList.remove(
        "product-model-overflow-hidden"
    );

    if (lastFocusedElement) {
        lastFocusedElement.focus();
    }

}

/* ==========================
   Mobile Flickity
========================== */

let flkty = null;

function initMobileGallery() {

    const slider = document.querySelector(".js-gallery-slider");

    if (!slider) return;

    // Desktop
    if (window.innerWidth > 767) {

        if (flkty) {
            flkty.destroy();
            flkty = null;
        }

        return;
    }

    if (typeof Flickity === "undefined") {
        console.log("Flickity not loaded");
        return;
    }

    if (flkty) return;

    flkty = new Flickity(slider, {
        cellSelector: ".gallery-cell",
        cellAlign: "left",
        contain: true,
        draggable: true,
        pageDots: false,
        prevNextButtons: false,
        percentPosition: true,
        adaptiveHeight: false
    });

    /* ======================
       Progress Bar
    ====================== */

    const progress = document.querySelector(".product-gallery-progress span");

    function updateProgress() {

        if (!progress) return;

        const total = flkty.slides.length;
        const progressValue = (flkty.selectedIndex + 1) / total;

        progress.style.width = (progressValue * 100) + "%";
    }

    updateProgress();

    flkty.on("change", updateProgress);

}

/* Load */
document.addEventListener("DOMContentLoaded", initMobileGallery);

/* Resize */
window.addEventListener("resize", function () {
    clearTimeout(window.galleryResize);
    window.galleryResize = setTimeout(function () {
        if (window.innerWidth > 767) {
            if (flkty) {
                flkty.destroy();
                flkty = null;
            }
        } else {
            if (!flkty) {
                initMobileGallery();
            } else {
                flkty.resize();
            }
        }

    }, 200);

});


document.addEventListener("keydown", function (e) {

    if (popup.classList.contains("active")) return;

    const item = e.target.closest(".js-open-gallery");

    if (!item) return;

    if (e.key === "Enter" || e.key === " ") {

        e.preventDefault();
        item.click();

    }

});

popup.addEventListener("keydown", function(e){

    if(e.key !== "Tab") return;

    const focusable = [...popup.querySelectorAll(
        'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
    )].filter(el => !el.disabled && el.offsetParent !== null);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length-1];

    if(e.shiftKey){

        if(document.activeElement === first){

            e.preventDefault();
            last.focus();

        }

    }else{

        if(document.activeElement === last){

            e.preventDefault();
            first.focus();

        }

    }

});

document.addEventListener("keydown", function(e){

    if(popup.classList.contains("active")) return;

    const active = document.activeElement.closest(".js-open-gallery");

    if(!active) return;

    const items = [...document.querySelectorAll(".js-open-gallery")];

    let index = items.indexOf(active);

    if (e.key === "ArrowRight") {

        e.preventDefault();

        const next = (index + 1) % items.length;
        items[next].focus();

    }

    if (e.key === "ArrowLeft") {

        e.preventDefault();

        const prev = (index - 1 + items.length) % items.length;
        items[prev].focus();

    }

});

document.addEventListener("keydown", function (e) {

    const label = e.target.closest(".radio__label");

    if (!label) return;

    if (e.key !== "Enter" && e.key !== " ") return;

    e.preventDefault();

    const input = document.getElementById(label.getAttribute("for"));

    if (!input) return;

    input.checked = true;

    input.click();

    input.dispatchEvent(new Event("change", {
        bubbles: true
    }));

});

document.querySelectorAll(".modal__utility").forEach(details => {

    const summary = details.querySelector("summary");
    const closeBtn = details.querySelector(".modal-close");

    details.addEventListener("toggle", () => {

        if(details.open){

            summary.setAttribute("aria-expanded","true");

            requestAnimationFrame(() => {
                closeBtn?.focus();
            });

        }else{

            summary.setAttribute("aria-expanded","false");

            summary.focus();

        }

    });

    details.addEventListener("keydown",function(e){

        if(e.key === "Escape"){

            details.open = false;
            summary.focus();

        }

    });

});

document.querySelectorAll(".modal__utility").forEach(details => {

    details.addEventListener("keydown",function(e){

        if(!details.open || e.key !== "Tab") return;

        const focusable = [...details.querySelectorAll(
            'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
        )].filter(el=>!el.disabled && el.offsetParent !== null);

        if(!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length-1];

        if(e.shiftKey){

            if(document.activeElement === first){

                e.preventDefault();
                last.focus();

            }

        }else{

            if(document.activeElement === last){

                e.preventDefault();
                first.focus();

            }

        }

    });

});

document.querySelectorAll("number-spinner").forEach(spinner => {

    const input = spinner.querySelector('[data-ref="input"]');
    const increase = spinner.querySelector('[data-ref="increaseButton"]');
    const decrease = spinner.querySelector('[data-ref="decreaseButton"]');
    const live = spinner.querySelector('[data-quantity-live]');

    function announce() {
        if (live) {
            live.textContent = "Quantity " + input.value;
        }
    }

    increase?.addEventListener("click", announce);
    decrease?.addEventListener("click", announce);

    input?.addEventListener("change", announce);

});


function isTouchDevice() {
    return (
        window.matchMedia("(hover: none) and (pointer: coarse)").matches
    );
}

function initVariantTooltips() {

    const tooltips = document.querySelectorAll(".variant-tooltip");

    if (!tooltips.length) return;

    if (isTouchDevice()) {
        tooltips.forEach(tooltip => {
            tooltip.style.display = "none";
        });

        return;
    }

    tooltips.forEach(tooltip => {
        tooltip.style.display = "";
    });
}

initVariantTooltips();

window.addEventListener("resize", function () {
    clearTimeout(window.variantTooltipResize);

    window.variantTooltipResize = setTimeout(function () {
        initVariantTooltips();
    }, 150);
});